// import parseTime, formatTime and set to filter
export { parseTime, formatTime, timestampToTime } from '@/utils'
import { car_message } from '@/utils/driver'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: 'E' },
    { value: 1e15, symbol: 'P' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'G' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
      )
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

// 过滤器
export function orderType(val) {
  if (val === 1) val = '预约一口价'
  if (val === 2) val = '导游订单'
  if (val === 3) val = '车+导订单'
  if (val === 4) val = '日租/半日租'
  if (val === 5) val = '即时订单'
  if (val === 16) val = '预约实时计价'
  return val
}

export function workSourceAgent(val) {
  /* 工单来源 1:我司 2:高德 3:美团 4:滴滴 5:阿里商旅 6:平安 */
  if (val === 1) val = '我司'
  if (val > 1) return '渠道同步'
  // if (val === 2) val = '高德'
  // if (val === 3) val = '美团'
  // if (val === 4) val = '滴滴'
  // if (val === 5) val = '阿里商旅'
  // if (val === 6) val = '平安'
  // if (val === 7) val = '哈啰'
  // if (val === 8) val = '滴滴-花小猪'
  // if (val === 9) val = '携程'
  // if (val === 10) val = '华为petal'
  // if (val === 11) val = '如祺'
  // if (val === 12) val = '腾讯'
  return val
}

export function feedbackSource(val) {
  /*
  用户身份 1:乘客 2:司机 3:渠道 4:警察 5:运管 6:工商 7:其他
   */
  if (val === 0) val = '--'
  if (val === 1) val = '乘客'
  if (val === 2) val = '司机'
  if (val === 3) val = '渠道'
  if (val === 4) val = '警察'
  if (val === 5) val = '运管'
  if (val === 6) val = '工商'
  if (val === 7) val = '其他'

  return val
}

export function feedbackChannel(val) {
  /*
  反馈渠道 1:邮件 2:微信 3:电话 4:客服群 5:线上退款 6:罚款单 7:对账单 8:差评明细 9:取消单 10:系统检测 11:VBK 12:申诉单 13:APP 14:公众号 15:在线 16:渠道同步 17:在线 20:司机报备 22:微信商户同步
   */
  if (val === 0) val = '--'
  if (val === 1) val = '邮件'
  if (val === 2) val = '微信'
  if (val === 3) val = '电话'
  if (val === 4) val = '客服群'
  if (val === 5) val = '线上退款'
  if (val === 6) val = '罚款单'
  if (val === 7) val = '对账单'
  if (val === 8) val = '差评明细'
  if (val === 9) val = '取消单'
  if (val === 10) val = '系统检测'
  if (val === 11) val = 'VBK'
  if (val === 12) val = '申诉单'
  if (val === 13) val = 'APP'
  if (val === 14) val = '公众号'
  if (val === 15) val = '在线'
  if (val === 16) val = '渠道同步'
  if (val === 17) val = '在线机器人'
  if (val === 20) val = '司机报备'
  if (val === 21) val = 'H5'
  if (val === 22) val = '微信商户同步'
  if (val === 23) val = 'ai反馈'

  return val
}

export function emerLevel(val) {
  /*
  工单级别 1:一般 2:紧急 3:非常紧急
   */
  if (val === 1) val = '一般'
  if (val === 2) val = '紧急'
  if (val === 3) val = '非常紧急'
  return val
}

export function workTypeFilter(val) {
  /*
  工单类型 1:客诉工单 2:申诉工单 3:报备工单
   */
  if (val === 1) val = '客诉'
  if (val === 2) val = '申诉'
  if (val === 3) val = '报备'
  return val
}

// 渠道
export function orderAgent(val) {
  // 即时
  if (val == 1) val = '携程预约'
  if (val == 2) val = '去哪儿'
  if (val == 3) val = '假日阳光'
  if (val == 5) val = '去哪儿当地人'
  if (val == 6) val = '企业用户'
  if (val == 7) val = '山海边'
  if (val == 8) val = '飞猪'
  if (val == 9) val = '途牛'
  if (val == 10) val = '携程改派单[规则]'
  if (val == 11) val = 'IOS'
  if (val == 12) val = '安卓'
  if (val == 13) val = 'Web'
  if (val == 14) val = 'H5'
  if (val == 15) val = '同程'
  if (val == 16) val = '后台'
  if (val == 17) val = 'Ios导游端'
  if (val == 18) val = '安卓导游端'
  if (val == 19) val = 'Ios司机端'
  if (val == 20) val = '钱包'
  if (val == 21) val = '携程线路订单'
  if (val == 22) val = 'app-ios司机端'
  if (val == 23) val = 'app-安卓司机端'
  if (val == 25) val = '阿里商旅'
  if (val == 28) val = '淘宝'
  if (val == 29) val = '美团'
  if (val == 30) val = '马蜂窝'
  if (val == 31) val = '携程玩乐'
  if (val == 32) val = '途牛线下'
  if (val == 33) val = '途家'
  if (val == 35) val = '网约车线上'
  if (val == 36) val = '网约车线下'
  if (val == 37) val = '悦享天下'
  if (val == 38) val = '114票务'
  if (val == 39) val = '蜘蛛旅游'
  if (val == 40) val = '中航易购'
  if (val == 41) val = '金色世纪'
  if (val == 42) val = '慧旅网'
  if (val == 59) val = '北京假日阳光环球旅行社有限公司'
  if (val == 66) val = '阳光与惠行'
  if (val == 68) val = '华住'
  if (val == 69) val = '笛岸旅游'
  if (val == 70) val = '重庆明揽天下国际旅行社有限公司'
  if (val == 71) val = '重庆宝中国际旅行社有限公司同创国际门市部'
  if (val == 72) val = '重庆顺程商务信息有限公司'
  if (val == 73) val = '深圳市天下房仓科技有限公司'
  if (val == 74) val = '在路上商旅'
  if (val == 75) val = '内部测试分销商'
  if (val == 76) val = '内部测试分销商2'
  if (val == 77) val = '和安商旅'
  if (val == 78) val = '稻果旅游网'
  if (val == 79) val = '嘻游记'
  if (val == 80) val = '飞巴商旅'
  if (val == 81) val = '广州任我行'
  if (val == 82) val = '风行天下'
  if (val == 83) val = '大华国旅'
  if (val == 84) val = '青旅江北茂业门市'
  if (val == 85) val = '飞宇天下'
  if (val == 86) val = '中旅总社重庆'
  if (val == 87) val = '泰达商旅'
  if (val == 88) val = '华亿旅行'
  if (val == 89) val = '美佳之旅'
  if (val == 90) val = '行旅国际'
  if (val == 91) val = '宇航体育'
  if (val == 92) val = '指南猫'
  if (val == 93) val = '蜗蜗游'
  if (val == 94) val = '众信旅游'
  if (val == 95) val = '北京德隆'
  if (val == 96) val = '铁航国旅'
  if (val == 97) val = '捷旅会展'
  if (val == 98) val = '凯撒商旅'
  if (val == 99) val = '合途旅游'
  if (val == 100) val = '商务部啊凤'
  if (val == 101) val = '南京康轩'
  if (val == 102) val = '上海嘉怡'
  if (val == 103) val = '婉居酒店'
  if (val == 104) val = '豪富国际'
  if (val == 105) val = '至活旅游'
  if (val == 106) val = '行旅教育'
  if (val == 107) val = '乐学营'
  if (val == 108) val = '华宇旅游'
  if (val == 109) val = '差旅天下'
  if (val == 110) val = '深圳特航航空'
  if (val == 111) val = '在路上'
  if (val == 112) val = '翔游旅行社'
  if (val == 113) val = '信诺全球出行'
  if (val == 114) val = '成都简百旅游'
  if (val == 115) val = '栖游记'
  if (val == 116) val = '柏大爷测试'
  if (val == 117) val = '辉煌国旅'
  if (val == 118) val = '720U（四川去哪）'
  if (val == 119) val = '九方逸程'
  if (val == 120) val = '百事通'
  if (val == 121) val = '途牛包车'
  if (val == 122) val = '春秋旅游'
  if (val == 123) val = '吉粮惠民'
  if (val == 124) val = '新华公务网'
  if (val == 125) val = '京燕旅航'
  if (val == 126) val = '胜意科技'
  if (val == 127) val = '渝之旅解放碑门市'
  if (val == 128) val = '乐畅国旅奥体路门市'
  if (val == 129) val = '重庆汇丰国旅渝中区门市'
  if (val == 130) val = '重庆中青旅大坪英利国际门市'
  if (val == 131) val = '宾至网'
  if (val == 132) val = '广州美旅'
  if (val == 133) val = '途牛定制'
  if (val == 134) val = '泛嘉国际'
  if (val == 135) val = '淘宝定制'
  if (val == 136) val = '淘宝线路'
  if (val == 137) val = '美团线路'
  if (val == 138) val = '途牛店铺'
  if (val == 139) val = '济南海岛旅行社'
  if (val == 140) val = '空港壹嘉'
  if (val == 141) val = '四川小雨'
  if (val == 142) val = '测试公司孙'
  if (val == 143) val = '小强停车'
  if (val == 144) val = '深圳美亚'
  if (val == 145) val = '广州美亚'
  if (val == 146) val = '携程玩乐线路'
  if (val == 147) val = '龙腾捷旅'
  if (val == 148) val = '医护到家'
  if (val == 149) val = '小程序'
  if (val == 150) val = '春秋旅游其它城市'
  if (val == 151) val = '金鹏航空'
  if (val == 152) val = '驴妈妈'
  if (val == 153) val = '在路上(上海)'
  if (val == 154) val = '南航'
  if (val == 155) val = '海航商旅'
  if (val == 156) val = '可缘商旅'
  if (val == 157) val = '四川商旅国际'
  if (val == 158) val = '凯撒国旅'
  if (val == 159) val = '阿胖旅游'
  if (val == 160) val = '携程玩乐店铺'
  if (val == 161) val = '北京英才硕博'
  if (val == 162) val = '上海天君'
  if (val == 163) val = '佛山上游'
  if (val == 164) val = '风岭旅游'
  if (val == 165) val = '中青畅游'
  if (val == 166) val = '果粒网'
  if (val == 167) val = '保盛航空'
  if (val == 168) val = '上海汽车城'
  if (val == 170) val = '江西昌永'
  if (val == 171) val = '蜘蛛线下'
  if (val == 172) val = '环境国旅线下'
  if (val == 173) val = '通讯学院线下'
  if (val == 174) val = '蜜柚旅行线下'
  if (val == 176) val = '成都环球六分社'
  if (val == 177) val = '龙腾线下'
  if (val == 178) val = '环球雅途线下'
  if (val == 179) val = '百场汇线下'
  if (val == 180) val = '差旅一号线下'
  if (val == 181) val = '游心商旅线下'
  if (val == 182) val = '张一晨线下'
  if (val == 183) val = '差旅天下线下'
  if (val == 184) val = '卧克线下'
  if (val == 185) val = '惠登国旅线下'
  if (val == 186) val = '阿胖旅行线下'
  if (val == 187) val = '行旅商旅线下'
  if (val == 188) val = '行旅教育线下'
  if (val == 189) val = '6人游线下'
  if (val == 190) val = '中青畅游线下'
  if (val == 191) val = '阿凤客户线下'
  if (val == 192) val = '深圳特航线下'
  if (val == 193) val = '黑龙江中青线下'
  if (val == 194) val = '盈科旅行线下'
  if (val == 195) val = '京东线下'
  if (val == 196) val = '指南猫线下'
  if (val == 197) val = '上海嘉怡线下'
  if (val == 198) val = '优行商旅线下'
  if (val == 199) val = '凯撒国旅线下'
  if (val == 200) val = '凯撒定制线下'
  if (val == 201) val = '知行走天下线下'
  if (val == 202) val = '悦享天下线下'
  if (val == 203) val = '北京身边惠线下'
  if (val == 204) val = '锦华任行线下'
  if (val == 205) val = '广东大粤线下'
  if (val == 206) val = '北京在路上线下'
  if (val == 207) val = '上海在路上线下'
  if (val == 208) val = '飞天下线下'
  if (val == 209) val = '美亚api'
  if (val == 210) val = '佛山上游线下'
  if (val == 211) val = '宇航体育线下'
  if (val == 212) val = '重庆风岭'
  if (val == 213) val = '重庆乐游国际旅行社大坪门店'
  if (val == 214) val = '山水假日（上海）'
  if (val == 215) val = '途家'
  if (val == 216) val = '妙知旅'
  if (val == 217) val = '武汉远洋国际'
  if (val == 218) val = '游牧星球'
  if (val == 219) val = '杭州泛嘉线下'
  if (val == 220) val = '佳熹航空线下'
  if (val == 221) val = '重庆风岭线下'
  if (val == 222) val = '上海京燕线下'
  if (val == 223) val = '济南海岛线下'
  if (val == 224) val = '成都环球六分社线下'
  if (val == 225) val = '上海至活线下'
  if (val == 226) val = '上海恒顺线下'
  if (val == 227) val = '广州穗阳线下'
  if (val == 228) val = ' 妙知旅线下'
  if (val == 229) val = ' 卧客线下'
  if (val == 230) val = '中新融创线下'
  if (val == 231) val = '锦华股份'
  if (val == 232) val = '苏州极客 '
  if (val == 233) val = '胜意科技线下'
  if (val == 235) val = '淘宝线下'
  if (val == 236) val = '广州豪富线下'
  if (val == 237) val = '空港易行线下'
  if (val == 238) val = '中旅线下'
  if (val == 239) val = '春秋包车线下'
  if (val == 240) val = '足印航空'
  if (val == 241) val = '优加线下'
  if (val == 242) val = '张凡线下'
  if (val == 243) val = '东莞庆华'
  if (val == 244) val = '赢加国旅线下'
  if (val == 245) val = '上海天君线下'
  if (val == 246) val = '正途线下'
  if (val == 247) val = '引领假日线下'
  if (val == 248) val = '众信线下'
  if (val == 251) val = '测试01'
  if (val == 252) val = '苏州极客线下'
  if (val == 253) val = '嘉兴市假日国旅线下'
  if (val == 254) val = '趣旅'
  if (val == 255) val = '测试分销商'
  if (val == 256) val = '同程商旅线下'
  if (val == 257) val = '海欧线下'
  if (val == 258) val = '臧飞7次元'
  if (val == 259) val = '途牛外包定制'
  if (val == 260) val = '锦华'
  if (val == 261) val = '携程定制包车'
  if (val == 262) val = '美食与你测试'
  if (val == 263) val = '淘宝'
  if (val == 264) val = '企业用户'
  if (val == 265) val = '广之旅线下'
  if (val == 266) val = '深圳沃亚线下'
  if (val == 267) val = '同程商旅'
  if (val == 268) val = '湖南海外'
  if (val == 269) val = '广州美亚'
  if (val == 270) val = '卧客国旅'
  if (val == 271) val = '广州美亚尚途'
  if (val == 272) val = '凯撒国旅'
  if (val == 273) val = '飞天下'
  if (val == 274) val = '途牛定制'
  if (val == 275) val = '广州穗阳'
  if (val == 276) val = '天鹅定制旅行'
  if (val == 277) val = '父母邦'
  if (val == 278) val = '优行商旅'
  if (val == 279) val = '驴妈妈'
  if (val == 283) val = '测试吴欢'
  if (val == 284) val = '空手到'
  if (val == 285) val = '户外国旅湖南分公司'
  if (val == 286) val = '北京在路上山水线下'
  if (val == 287) val = '身边惠'
  if (val == 288) val = '河北猎景国旅'
  if (val == 289) val = '假日阳光'
  if (val == 290) val = '高德'
  if (val == 291) val = '悦行线下'
  if (val == 292) val = '王群培训'
  if (val == 293) val = '河南中州国旅'
  if (val == 294) val = '贴心国旅'
  if (val == 295) val = '携程即时用车'
  if (val == 296) val = '北京麦炽'
  if (val == 297) val = '春秋航空'
  if (val == 298) val = '空港易行'
  if (val == 299) val = '重庆中旅'
  if (val == 300) val = '上海翼信'
  if (val == 301) val = '鸿泰假日'
  if (val == 302) val = '美团即时用车'
  if (val == 332) val = '小黑鱼'
  if (val == 333) val = '滴滴即时用车'
  if (val == 334) val = '腾讯即时用车'
  if (val == 335) val = '百度即时用车'
  if (val == 336) val = '国铁'
  if (val == 338) val = '阿里商旅即时用车'
  if (val == 339) val = '飞常准'
  if (val == 340) val = '飞常准即时用车'
  if (val == 341) val = '游网时空'
  if (val == 342) val = '游网时空即时用车'
  if (val == 343) val = '高铁管家'
  if (val == 345) val = '中联航'
  if (val == 346) val = '悦途预约'
  if (val == 347) val = '同程即时'
  if (val == 349) val = '平安'
  if (val == 350) val = '12306'
  if (val == 353) val = '巴士管家即时'
  if (val == 354) val = '巴士管家预约'
  if (val == 355) val = '汽车之家即时'
  if (val == 356) val = '汽车之家预约'
  if (val == 357) val = '分贝通即时'
  if (val == 358) val = '租租车即时'
  if (val == 359) val = '租租车预约'
  if (val == 360) val = '秒走预约'
  if (val == 361) val = '秒走即时'
  if (val == 365) val = '哈啰即时'
  if (val == 366) val = '金保证即时'
  if (val == 370) val = '摩登出行预约'
  if (val == 371) val = '差旅一号即时'
  if (val == 372) val = '差旅一号预约'
  if (val == 374) val = '在路上（北京）即时'
  if (val == 375) val = '航旅纵横即时'
  if (val == 376) val = '航旅纵横预约'
  if (val == 377) val = '滴滴-百度地图即时'
  if (val == 378) val = '滴滴-腾讯地图即时'
  if (val == 379) val = '小程序扫码下单'
  if (val == 380) val = '在路上（路路云购）预约'
  if (val == 381) val = '在路上（上海）即时'
  if (val == 382) val = '在路上（路路云购）即时'
  if (val == 383) val = '万讯即时'
  if (val == 384) val = '万讯预约'
  if (val == 385) val = '一汽快马即时'
  if (val == 386) val = '一汽快马预约'
  if (val == 387) val = '给乐即时'
  if (val == 388) val = '销巴生活即时'
  if (val == 389) val = '庆华航空即时'
  if (val == 390) val = '首都机场旅业即时'
  if (val == 391) val = '车诚智行即时'
  if (val == 394) val = '美团预约用车'
  if (val == 9999) val = '阳光出行即时用车'
  if (val == 402) val = '高德预约实时计价'
  if (val == 401) val = '滴滴-花小猪'
  return val
}

export function workTypeDetail(val) {
  if (val === 21) val = '扣罚申诉'
  if (val === 22) val = '改派申诉'
  if (val === 23) val = '风控申诉'
  if (val === 24) val = '未及时就位申诉'
  if (val === 25) val = '扣款申诉'
  if (val === 26) val = '罚款申诉'
  if (val === 31) val = '司机报备'
  if (val === 32) val = '后台报'

  return val
}

// 使用渠道 1:人工 2:APP
export function useAgent(val) {
  if (val === 1) val = '人工'
  if (val === 2) val = ' APP'
  return val
}
// 启用状态 1:启用 2:禁用
export function enabledString(val) {
  if (val === 1) val = '启用'
  if (val === 2) val = ' 禁用'
  return val
}

// 下线类型 0:不下线 1:下线 2:永久下线 3:静默 4:派单降级（不下线）
export function offlineType(val) {
  if (val === 0) val = '不下线'
  if (val === 1) val = '临时下线'
  if (val === 2) val = '永久下线'
  if (val === 4) val = '派单降级（不下线）'
  return val
}
export function enabledButton(val) {
  if (val === 1) val = '禁用'
  if (val === 2) val = '启用'
  return val
}
// 是否可申诉 1:是 2:否
export function isAppeal(val) {
  if (val === 1) val = '是'
  if (val === 2) val = '否'
  return val
}
// 用户身份 1:乘客 2:司机 3:渠道,4 警察 5工商 6媒体 7运管 8其他
export function userIdentity(val) {
  if (val === 1) val = '乘客'
  if (val === 2) val = '司机'
  if (val === 3) val = '渠道'
  if (val === 4) val = '警察'
  if (val === 5) val = '工商'
  if (val === 6) val = '媒体'
  if (val === 7) val = '运管'
  if (val === 8) val = '其他'
  if (val === 0) val = '--'
  return val
}
// 标签分类 1:咨询 2:报备 3:投诉 4:风控 5:申诉
export function titleType(val) {
  if (val === 1) val = '咨询'
  if (val === 2) val = '报备'
  if (val === 3) val = '投诉'
  if (val === 4) val = '风控'
  if (val === 5) val = '申诉'
  return val
}
// 自动判责类型
export function judgeType(val) {
  if (val === 1) val = '未乘车扣费'
  if (val === 2) val = '超时判责'
  if (val === 3) val = '司机绕路'
  if (val === 4) val = '费用异常'
  if (val === 5) val = '恶意附加费'
  if (val === 6) val = '司机绕路/费用异常+恶意附加费'
  if (val === 7) val = '高德客服人工判责'
  if (val === 8) val = '其他方式已付费'
  if (val === 26) val = '高德客服司机服务判责'
  if (val === 100) val = '线下导入'

  return val
}

// 介入类型 1:人工介入 2:系统介入
export function interposeType(val) {
  if (val === 1) val = '是'
  if (val === 2) val = '否'
  return val
}
export function workStatus(val) {
  //  1 待我受理
  //  2 我已完成
  //  0 全部工单
  if (val === 1) val = '待处理'
  if (val === 2) val = '处理中'
  if (val === 3) val = '已完成'
  return val
}

export function workType(val) {
  // 工单类型 1:客诉工单 2:申诉工单 3:报备工单

  switch (val) {
    case 0:
      val = '咨询'
      break
    case 1:
      val = '客诉工单'
      break
    case 2:
      val = '申诉工单'
      break
    case 3:
      val = '报备工单'
      break
    // default:
    //   val = val
  }
  return val
}
// 姓名
export function nameenc(val) {
  if (val.length >= 3) {
    return val.replace(/^(.+).(.)$/, '$1*$2')
  }
  if (val.length == 2) { // 两位的姓名，后面以为变星号
    return val.replace(/^.(.+)$/, '*$1')
  }
}
// 车牌号
export function carenc(val) {
  return val.replace(/^(.{3}).*(.{1})/, '$1***$2')
}
// 工单标签类型
export function labelType(val) {
  if (val === 1) val = '工单'
  if (val === 2) val = '责任方'
  if (val === 3) val = '司机处罚'
  if (val === 4) val = '内部流转'
  if (val === 5) val = '质检'
  return val
}

// 质检申诉结果
export function resultStatus(val) {
  if (val.qc_result <= 1) val = '--'
  if (val.qc_apel_result_status === 1) val = '成功'
  if (val.qc_apel_result_status === 2) val = '失败'
  if (val.qc_apel_result_status === 0 && val.qc_apel_status === 0) {
    val = '未申诉'
  }
  if (val.qc_apel_result_status === 0 && val.qc_apel_status === 2) {
    val = '处理中'
  }
  if (val.qc_apel_result_status === 0 && val.qc_apel_status === 1) {
    val = '待处理'
  }

  return val
}
// 质检 质检结果
export function QcResult(val) {
  if (val === 0) val = '--'
  if (val === 1) val = '通过'
  if (val === 2) val = '不通过'
  return val
}
// 质检 质检状态
export function QcStatus(val) {
  if (val === 3) val = '待质检'
  if (val === 2) val = '质检中'
  if (val === 1) val = '已质检'
  if (val === 0) val = '未质检'
  return val
}
// 质检 申诉状态
export function appealStatus(val) {
  if (val === 1) val = '待处理'
  if (val === 2) val = '处理中'
  if (val === 3) val = '处理完成'
  if (val === 0) val = '未申诉'
  return val
}

// 工单 工单违规标签关闭接单
export function closeReceive(val) {
  if (val === 1) val = '是'
  if (val === 2) val = '否'
  return val
}

export function IsOnline(val) {
  if (val == 1) val = '上线'
  if (val == 2) val = '下线'
  if (val == 0) val = '--'
  return val
}

// 群业务类型
export function groupType(val) {
  switch (val) {
    case 1:
      val = '公海'
      break
    case 2:
      val = '车队'
      break
    // default:
    //   val = val
  }
  return val
}

// 罚款处罚类型 1:罚款 2:罚款冻结 是否冻结 1:否 2:是
export function punishFeeType(val) {
  if (val === 1) val = '否'
  if (val === 2) val = '是'
  return val
}

// 群聊操作记录操作类型 1：批量添加群成员 2：批量踢出群成员 3：批量创建群组
export function operationType(val) {
  if (val === 1) val = '批量添加群成员'
  if (val === 2) val = '批量踢出群成员'
  if (val === 3) val = '批量创建群组'
  if (val === 4) val = '批量发送群消息'
  if (val === 5) val = '批量设置管理员'
  return val
}

// 工单安全级别
 export function safetyLevel(val) {
   if (val == 'A1') val = 'A1特别重大级+特别紧急'
   if (val == 'B1') val = 'B1重大级+特别紧急'
   if (val == 'B2') val = 'B2重大级+紧急'
   if (val == 'B3') val = 'B3重大级+较急'
   if (val == 'C2') val = 'C2较大级+紧急'
   if (val == 'C3') val = 'C3较大级+较急'
   if (val == 'D2') val = 'D2较大级+紧急'
   if (val == 'D3') val = 'D3一般+较急'
   if (val == 'C4') val = 'C4较大级+一般'
   if (val == 'D4') val = 'D4一般'
   return val
 }

//  工单责任方
export function workOrderBlame(val) {
   if (val == 1) val = '乘客'
   if (val == 2) val = '司机'
   if (val == 3) val = '不可抗力'
   if (val == 4) val = '渠道'
   if (val == 5) val = '系统'
   if (val == 6) val = '客服'
   if (val == 7) val = '我司'
   if (val == 8) val = '其他'
   return val
}

//  工单责任方
export function workCategory(val) {
  if (val == 0) return '二线工单'
  if (val == 1) return '一线关单'
  return '-'
}

// 用户身份、反馈方式
export function feedbackSourceChannel(val,options) {
  for (let i = 0; i < options.length; i++) {
    const element = options[i]
    if (element.id == val) {
      return element.value
    }
  }
  return val
}

// 工单默认筛选
export function workOrderDefaultFilter(val, options) {
  const obj = options.find(item => item.id == val)
  return obj?.value ?? ''
}

// 车辆燃料类型
export function fuelType(val) {
  const fuel_types = car_message.fuel_type
  // 去枚举库里根据传递过来的数字找到对应的对象
  const obj = fuel_types.find(v => v.value == val)
  return obj?.label ?? ''
}
